import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { DocumentModel } from '../../../shared/models/document.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { ChannelCommunicatorService, } from '../../../shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { ValidationHelperService } from '../../../shared/services/helpers/validation-helper.service';
import { IdentificationService } from '../../../shared/services/identification/identification.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { TaggingService } from '../../../shared/services/tagging/tagging.service';
import { FingerPrintScanImage } from './finger-print-scan-image';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
var FingerPrintsScanComponent = /** @class */ (function () {
    function FingerPrintsScanComponent(copyService, abreCuentasService, parametersService, channelCommunicatorService, navigationService, validationHelperService, headerService, identificationService, taggingService, loaderService, bitacoraService) {
        this.copyService = copyService;
        this.abreCuentasService = abreCuentasService;
        this.parametersService = parametersService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.navigationService = navigationService;
        this.validationHelperService = validationHelperService;
        this.headerService = headerService;
        this.identificationService = identificationService;
        this.taggingService = taggingService;
        this.loaderService = loaderService;
        this.bitacoraService = bitacoraService;
        this.isBtnDisabled = true;
        this.infoDocument = new DocumentModel();
        this.headerService.show(true, true, true);
        this.maxScanAttempts = this.abreCuentasService.getBytteConfig().failedAttempts.fingerPrintsScan;
        this.callIncomesError = false;
        this.incomesRequest = false;
        this.clientDataRequest = false;
    }
    FingerPrintsScanComponent.prototype.ngOnInit = function () {
        this.image = {
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: FingerPrintScanImage,
        };
        this.infoDocument = this.abreCuentasService.getDocumentInfo();
    };
    FingerPrintsScanComponent.prototype.next = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.callScanNewVersions()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        // this.loaderService.hide();
                        console.log(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FingerPrintsScanComponent.prototype.resumeApp = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tagPageName;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // this.loaderService.show();
                        if (!this.scanResponse.code) {
                            // this.loaderService.hide();
                            this.navigationService.navigateToGeneralInformation('500');
                            return [2 /*return*/];
                        }
                        switch (this.scanResponse.code) {
                            case '400': // Wrong license activation key
                            case '403': // Origin not authorized
                            case '404': // Operation not found
                            case '500': // Internal error
                                // this.loaderService.hide();
                                this.navigationService.navigateToGeneralInformation('500');
                                return [2 /*return*/];
                            case '504': // Failed attempt
                                // this.loaderService.hide();
                                this.abreCuentasService.getAbreCuentasModel().fingerPrintsScanAttempts++;
                                if (this.abreCuentasService.getAbreCuentasModel().fingerPrintsScanAttempts >= this.maxScanAttempts) {
                                    this.navigationService.pageLoadTag('ErrorHuellasInvalidas', ['pv20', 'pv115', 'pv75', '']);
                                    this.abreCuentasService.caseInfoError('102');
                                    this.navigationService.nextStep('102');
                                }
                                else {
                                    this.navigationService.pageLoadTag('ErrorCapturaHuellas', ['pv222', 'pv114', 'pv74', '']);
                                    this.abreCuentasService.setImageLottieError(this.image);
                                    this.abreCuentasService.caseInfoError('113');
                                    this.navigationService.nextStep('113');
                                }
                                // this.loaderService.hide();
                                return [2 /*return*/];
                        }
                        this.navigationService.pageLoadTag(false, ['pv19', 'pv108', 'pv67']);
                        tagPageName = this.taggingService.getTagIdByProduct();
                        this.pageTagEvent(tagPageName);
                        return [4 /*yield*/, this.sendFingerPrints()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FingerPrintsScanComponent.prototype.sendFingerPrints = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.identificationService
                            .sendFingerPrintsInfo(this.scanResponse)
                            .then(function (res) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var nextCode, codigo, bitacoraEvent;
                            return tslib_1.__generator(this, function (_a) {
                                this.channelCommunicatorService.getImpl().cleanResidualFiles();
                                if (res.status === 500) {
                                    // this.loaderService.hide();
                                    this.navigationService.nextStep('200');
                                    return [2 /*return*/];
                                }
                                if (res.status !== 200) {
                                    codigo = res.body.codigo;
                                    switch (codigo) {
                                        case '422-01':
                                        case '422-02':
                                        default:
                                            nextCode = '103';
                                            break;
                                    }
                                    // this.loaderService.hide();
                                    this.navigationService.nextStep(nextCode);
                                }
                                else if (res.body.verification_status === 'false') {
                                    nextCode = '102';
                                    // this.loaderService.hide();
                                    this.abreCuentasService.caseInfoError('102');
                                    this.navigationService.nextStep(nextCode);
                                    return [2 /*return*/];
                                }
                                nextCode = '200';
                                bitacoraEvent = 'biometric-validation-proces-succes';
                                this.bitacoraService.saveDataInBitacora(bitacoraEvent);
                                this.navigationService.nextStep(nextCode);
                                return [2 /*return*/];
                            });
                        }); }).catch(function () {
                            _this.navigationService.navigateToGeneralInformation('500');
                            // this.loaderService.hide();
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FingerPrintsScanComponent.prototype.pageTagEvent = function (tagPageName) {
        try {
            var changes = [
                {
                    path: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionDetailsProductcategory"].path,
                    value: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionDetailsProductcategory"].value,
                },
                {
                    path: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionName"].path,
                    value: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionName"].value,
                },
            ];
            var event_1 = {
                category: {
                    module: EVENT.customCategory.module.body,
                    type: EVENT.customCategory.type.image,
                    position: EVENT.customCategory.position.center,
                },
                action: EVENT.customAction.show,
                label: EVENT[tagPageName + "E1customLabel"],
            };
            this.taggingService.pageTagEvent(event_1, changes);
        }
        catch (error) {
            console.log(error);
        }
    };
    FingerPrintsScanComponent.prototype.callScanNewVersions = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.channelCommunicatorService
                            .getImpl()
                            .verifyAndRequestPermissions()
                            .then(function (p) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var finger, seconds;
                            var _this = this;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!p.code || p.code !== '200') {
                                            // this.loaderService.hide();
                                            this.navigationService.navigateToGeneralInformation('401');
                                        }
                                        finger = this.abreCuentasService.getDocumentInfo().finger_printed.toString();
                                        seconds = this.abreCuentasService.getBytteConfig().timeouts.fingerPrintsScan.seconds;
                                        return [4 /*yield*/, this.channelCommunicatorService.getImpl().fingerPrintsScan(finger, this.abreCuentasService.getTransactionId(), seconds).then(function (e1) {
                                                // this.loaderService.hide();
                                                _this.scanResponse = e1;
                                                _this.resumeApp();
                                            }).catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }).catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return FingerPrintsScanComponent;
}());
export { FingerPrintsScanComponent };
